import { getRealtimeCredentialMatches } from '@/libraries/api/credentialMismatch'
import moment from 'moment'
import { fakeIentityMatchingGenderOfFace } from '@/libraries/util/demoData'
import * as flags from '@/libraries/util/flags'

const mostRecentDetection = (detectionA, detectionB) => {
  if (detectionA.event_ts > detectionB.event_ts) {
    return detectionA
  } else return detectionB
}

const mapPersonObject = (detection) => {
  if (flags.DemoDataForFaces.enabled) {
    const demo = fakeIentityMatchingGenderOfFace(detection)
    detection.given_name = demo.firstName
    detection.surname = demo.lastName
  }
  return {
    name: `${detection.given_name} ${detection.surname}`,
    credentialUUID: detection.credential_uuid,
    lastSeen: detection.event_ts,
    detections: [detection.access_event_uuid],
    confidence: detection.best_match_confidence,
    mostRecentAccessEventUUID: detection.access_event_uuid,
  }
}

export const RealtimeCredentials = {
  namespaced: true,
  state: {
    credentialsByUUID: {},
    accessEventsByUUID: {},
    identityIDFilter: undefined,
  },
  mutations: {
    processAccessEventPayload (state, accessEvents) {
      accessEvents.forEach(detection => {
        const accessEventUUID = detection.access_event_uuid
        const existingAccessEvent = state.accessEventsByUUID[accessEventUUID]

        // process access event data
        // console.log(existingAccessEvent !== detection)
        if (!existingAccessEvent) {
          const detMoment = moment.utc(detection.event_ts, 'YYYY-MM-DDTkk:mm:ss')
          detection.lastSeenUnixTimestamp = detMoment.local().valueOf()
          detection.lastSteen = detMoment.local().format('MM/DD/YYYY hh:mm:ss A')
          state.accessEventsByUUID = { ...state.accessEventsByUUID, [accessEventUUID]: detection }
        } else if (existingAccessEvent !== detection) {
          // copies the existing access event fields (e.g. lastSeen, and unix ts) but replaces fields that may have changed like matches
          state.accessEventsByUUID = { ...state.accessEventsByUUID, [accessEventUUID]: { ...existingAccessEvent, ...detection } }
        }

        // process credential data
        const credentialUUID = detection.credential_uuid
        const existingProfile = state.credentialsByUUID[credentialUUID]
        let personObj = {}
        if (!existingProfile) {
          personObj = mapPersonObject(detection)
        } else {
          const prevMostRecentDetection = state.accessEventsByUUID[existingProfile.mostRecentAccessEventUUID]
          const mostRecent = mostRecentDetection(detection, prevMostRecentDetection)
          personObj = { ...existingProfile, lastSeen: mostRecent.lastSteen, confidence: mostRecent.best_match_confidence }
          if (!existingAccessEvent) {
            personObj.detections = [ detection.access_event_uuid, ...personObj.detections ]
          }
        }
        state.credentialsByUUID = { ...state.credentialsByUUID, [personObj.credentialUUID]: personObj }
      })
    },
    setIdentityIDFilter (state, id) {
      state.identityIDFilter = id
    },
  },
  getters: {
    sortedDetections (state) {
      const arr = Object.entries(state.accessEventsByUUID).map(detection => detection[1]).sort((detectionA, detectionB) => {
        return detectionB.lastSeenUnixTimestamp - detectionA.lastSeenUnixTimestamp
      })
      console.log(arr.length)
      return arr
    },
    roster (state) {
      const list = Object.entries(state.credentialsByUUID)
      const mapped = list.map(value => { return value[1] })
      return mapped
    },
    credentialsByUUID (state) {
      return state.credentialsByUUID
    },
    currentIdentityId (state) {
      return state.identityIDFilter
    },
  },
  actions: {
    async getRealtimeCredentialMatches ({ rootState, commit }, payload) {
      const currentDomainUUID = rootState.data.domains.current.uuid
      getRealtimeCredentialMatches(currentDomainUUID).then((res) => {
        if (res.status === 200) {
          const data = res.data
          if (data.ok) {
            const events = data.access_events
            commit('processAccessEventPayload', events)
          } else {
            console.log(`data not ok`)
          }
        } else {
          console.log('res not ok')
          console.log(res)
        }
      }).catch(error => {
        console.log(`Error! ${error}`)
      })
    },
  },
}
